<template>
    <div id="community-area">
        <h2>Community</h2>

        <div class="community-content">
            <div class="community-display">

                <!-- Top Community Section -->
                <div class="custom-community-units">
                    <div class="community-tabs-nav">
                        <h4>Recommended Units</h4><hr>
                        <button class="tab-btn" v-for="tabBtn in tabBtns" v-bind:key="tabBtn" @click="selectTab(tabBtn)"></button>
                    </div>
                    <!-- <div class="carousel-ctrl">
                        <button @click="sliderLeft()"><i class="fas fa-arrow-circle-left"></i></button>
                    </div> -->
                        <div class="custom-units-view">
                            <div class="tabContent" v-for="customUnit in customCommunityUnits" v-bind:key="customUnit">
                                <div class="unit-card" v-if="currentTab == customUnit.id">
                                    <div class="card-info">
                                        <h3 class="unit-title">{{ customUnit.title }}</h3>
                                        <p>{{ customUnit.description }}</p>
                                        <button class="round-btn-small">View</button>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="tabContent" v-if="currentTab == tab.id">
                                <div class="unit-card" v-for="customUnit in customCommunityUnits" v-bind:key="customUnit">
                                    <div class="card-info">
                                        <h3 class="unit-title">{{ customUnit.title }}</h3>
                                        <p>{{ customUnit.description }}</p>
                                        <button class="round-btn-small">View</button>
                                    </div>
                                </div>
                            </div> -->
                            
                            
                        </div>
                    <!-- <div class="carousel-ctrl">
                        <button @click="sliderRight()"><i class="fas fa-arrow-circle-right"></i></button>
                    </div> -->
                </div>

               <div class="all-community-units">
                    <div class="community-tabs-nav">
                        <h4>All Community Units</h4><hr>
                            <button class="tab-btn" v-for="tabBtn in tabBtns" v-bind:key="tabBtn" @click="selectTab(tabBtn)"></button>

                    </div>
                    <div class="all-units-view">
                        <div class="unit-card" v-for="unit in allCommunityUnits" v-bind:key="unit">
                            <div class="card-info">
                                <h3 class="unit-title">{{ unit.title }}</h3>
                                <p>{{ unit.description }}</p>
                                <button class="round-btn-small">View</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "community",
    data() {
        return {
        showSection: '',
        currentTab: 1,
        // sliderCounter: 1,
        tabBtns: [
            {"id": 1},
            {"id": 2},
            {"id": 3},
        ],
        // tabContent: [
        //     {"id": 1},
        //     {"id": 2},
        //     {"id": 3},
        // ],
        customCommunityUnits: [
            {"title": "Title1", "description": "a description about the unit", "id": 1},
            {"title": "Title2", "description": "a description about the unit", "id": 1},
            {"title": "Title3", "description": "a description about the unit", "id": 1},
            {"title": "Title4", "description": "a description about the unit", "id": 2},
            {"title": "Title5", "description": "a description about the unit", "id": 2},
            {"title": "Title6", "description": "a description about the unit", "id": 2},
            {"title": "Title7", "description": "a description about the unit", "id": 3},
            {"title": "Title8", "description": "a description about the unit", "id": 3},
            {"title": "Title9", "description": "a description about the unit", "id": 3},
            
        ],
        allCommunityUnits: [
            {"title": "Title1", "description": "a description about the unit"},
            {"title": "Title2", "description": "a description about the unit"},
            {"title": "Title3", "description": "a description about the unit"},
            {"title": "Title4", "description": "a description about the unit"},
            {"title": "Title5", "description": "a description about the unit"},
            {"title": "Title6", "description": "a description about the unit"},
        ],
    }
    
    },
    methods: {
        selectTab(tabBtn) {
                var vm = this;
                vm.currentTab = tabBtn.id;
                console.log(tabBtn)
        },
        


        // sliderRight() {
        //     var vm = this;
        //     var slide = vm.$refs.slide;
        //     var size = slide.clientWidth;
        //     var counter = vm.sliderCounter;
        //     counter++;
        //     slide.style.transform = 'translateX(-' + (size * counter) + 'px)';
        //     slide.style.transition = "transform 0.4s ease-in-out"
        //     console.log(size)
        // },
    }
}
</script>

<style scoped>

#community-area {
    height: 100%;
    width: 80rem;
    margin: 5rem auto 2rem auto;
    color: #434342;
}

.community-content {
    height: 100%;
}

#community-area h2 {
    font-family: 'Haboro-Soft', sans-serif !important;
}

.community-display {
    width: 100%;
    height: 100%;
    
}

.community-carousel h4 {
    margin: 0;
}

.custom-community-units {
   height: 375px;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
}

.all-community-units {
   margin-bottom: 30px;
    width: 100%;
    display: flex;  
    flex-wrap: wrap;
    align-items: center;
}

/* .carousel-slider {
    display: flex;
    width: 88%;
    margin: 0;
    height: 314px;
    overflow: hidden;
}  

/* .slide {
    display: flex;
} */ 

.community-tabs-nav {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
}

.community-tabs-nav hr:first-of-type {
    width: 80%;
    margin: 0;
    height: 12px;
}

.tab-btn {
    background-color: #f56a6a;
    height: 10px;
    width: 10px;
    padding: 0;
    border-radius: 50px;
    margin-right: 10px;
    margin-top: 5px;
}

.custom-units-view {
    display: flex;
    margin: 0 auto;
    height: 100%;
}

.all-units-view {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin: 0 auto;
    justify-content: space-between;
    align-content: space-between;
}

.unit-card {
    display: flex;
    flex-wrap: wrap;
    width: 350px;
    height: 300px;
    border-radius: 30px;
    background: #fff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    padding: 20px;
    background-image: url('/static/images/community-unit-card-bg.svg');
    background-repeat: no-repeat;
    align-content: flex-end;
    margin-left: 20px;
    margin-bottom: 40px;
}

.card-info {
    font-family: 'Haboro-Soft', sans-serif;
}

.card-info h3 {
    font-family: 'Haboro-Soft', sans-serif;
    margin: 0;
    font-weight: 600;
}

.card-info button {
    margin-left: 220px;
}

.tabContent {
    display: flex;
}
</style>
